import { Component } from '@angular/core';

@Component({
  selector: 'empathy-dropdown-description',
  templateUrl: 'dropdown-description.component.html',
  styleUrls: ['./dropdown-description.component.scss']
})
export class DropdownDescriptionComponent {}
